import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import { useParams } from "react-router-dom";
import DownloadExcel, { getRecords } from "../../../services/api.service";
import { CSVLink } from "react-csv";

const WarehouseDetails = () => {
  const { id } = useParams();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingData, setLoadingData] = useState(false);
  const recordsPerPage = 10;

  useEffect(() => {
    fetchReports();
    const handleStorageChange = () => {
      fetchReports();
    };
    window.addEventListener("dashboardUpdate", handleStorageChange);
    return () => {
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, []);

  const fetchReports = async () => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;

      const { project_id, warehouse_id, warehouse_type } =
        JSON.parse(dashboard_details);
      let payload = {
        modelName: "warehouse_masters",
        project_id,
        warehouse_id,
        warehouse_type,
      };

      let responseData = await getRecords(
        payload,
        "/dashboard/getWarehouseListing"
      );
      setLoadingData(false);
      if (responseData.code === 1 && responseData.data.length > 0) {
        setData([...responseData.data]);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filteredItems =
    data.filter(
      (row) =>
        row?.warehouse_name
          ?.toLowerCase()
          .includes(searchKeyword.toLowerCase()) ||
        row?.project_name?.toLowerCase().includes(searchKeyword.toLowerCase())
    ) || [];
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredItems.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredItems.length / recordsPerPage);

  const handleInputChange = (e) => {
    setSearchKeyword(e.target.value);
    setCurrentPage(1);
  };
  console.log("Data Length: ", data.length);
  console.log("Filtered Items: ", filteredItems);
  console.log("Current Page: ", currentPage);
  console.log("Total Pages: ", totalPages);
  // export code
  const columns = [
    { label: "Sr. No", key: "srNo" },
    { label: "Project Name", key: "project_name" },
    { label: "Customer Name", key: "customer_name" },
    { label: "Warehouse Type", key: "warehouse_type" },
    { label: "Warehouse Name", key: "warehouse_name" },
    { label: "State", key: "state" },
    { label: "City", key: "city" },
    { label: "Address", key: "address" },
  ];

  const csvData = filteredItems.map((row, index) => ({
    srNo: index + 1,
    project_name: row?.project_name || "N/A",
    customer_name: row?.customer_name || "N/A",
    warehouse_type:
      row?.warehouse_type == 1
        ? "Bermad"
        : row?.warehouse_type == 2
        ? "Contractor"
        : "N/A",
    warehouse_name: row?.warehouse_name || "N/A",
    state: row?.state || "N/A",
    city: row?.city || "N/A",
    address: row?.address || "N/A",
  }));

  const handleExportData = () => {
    DownloadExcel({
      fileName: "WarehouseDetails",
      columns: columns,
      data: csvData,
      cellColor: true,
    });
  };

  return (
    <CustomForm
      title="WAREHOUSE REPORT"
      id={id}
      loadingData={loadingData}
      noBackButton
      noSubmitButton
    >
      <Row className="mt-1">
        <Col lg={12}>
          <div>
            <div className="mb-2 d-flex justify-content-between align-items-center text-white">
              <div>
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search.."
                  value={searchKeyword}
                  onChange={handleInputChange}
                  style={{
                    width: "15rem",
                    padding: "8px 15px",
                    borderRadius: "8px",
                    borderColor: "#D2D2D2",
                  }}
                />
              </div>
              <div>
                <div onClick={handleExportData} className="btn btn-success">
                  Download CSV
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table
                className="table table-hover mb-0"
                style={{ border: "1px solid black" }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "#8AC1E8",
                  }}
                >
                  <tr>
                    <th>Sr. No</th>
                    <th>Project Name</th>
                    <th>Customer Name</th>
                    <th>Warehouse Type</th>
                    <th>Warehouse Name</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Address</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.length > 0 ? (
                    currentRecords.map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                        }}
                      >
                        <td>{indexOfFirstRecord + index + 1}</td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                            }}
                            title={row?.project_name || "N/A"}
                          >
                            {row?.project_name || "N/A"}
                          </div>
                        </td>{" "}
                        <td>{row?.customer_name || "N/A"}</td>
                        <td>
                          {row?.warehouse_type == 1
                            ? "Bermad"
                            : "Contractor" || "N/A"}
                        </td>
                        <td>{row?.warehouse_name || "N/A"}</td>
                        <td>{row?.state || "N/A"}</td>
                        <td>{row?.city || "N/A"}</td>
                        <td>{row?.address || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-primary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-primary"
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default WarehouseDetails;
